import axiosInstance from 'utils/axios';

export const getWorkshops = async () => {
    const { data } = await axiosInstance.get('api/pub/workshops');

    return data;
};

const workshopService = {
    getWorkshops,
};

export default workshopService;
